import React from 'react'

export const AboutPageSubTitle = ({title}) => {
  return (
    <h2 className='text-center text-2xl font-bold tracking-widest font-work'>{title} <span className='text-blue font-bold text-3xl'>-</span></h2>
  )
}
